import i18next from 'i18next';
import c from './../config/constants';
import ar_fallback from './ar_fallback.json';
import en_fallback from './en_fallback.json';
import h from '../helpers/common';

export const initLocalaization = (lang) => {
    i18next.init({
        interpolation: {
            escapeValue: false,
        },
        lng: h?.getLang() || c.DEFAULT_LANGUAGE,
        resources: {
            en: {
                translation: lang.en,
            },
            ar: {
                translation: lang.ar,
            },
            en_fallback: {
                translation: en_fallback,
            },
            ar_fallback: {
                translation: ar_fallback,
            },
        },
        fallbackLng: {
            an: ['en_fallback'],
            ar: ['ar_fallback'],
            default: ['en_fallback'],
        },
    });
};

export const __ = (key, keyPair = {}) => {
    return i18next.t(key, keyPair);
};

export default i18next;
